import { alertExamStatus } from "app/components/ExamStatus/utils/headExamStatus";
import { FEEDBACK_FORM_URL } from "app/constants";
import dayjs from "dayjs";

export const examStatusAlerts = {
  feedback: `💡 Hey there! We’d love your feedback! Share your thoughts here:`,
  graded: "✅ Your exam has been graded! Check your results now.",
  ongoing: "📖 Your exam is now in progress. Make sure to complete it before the deadline!",
  pending: "⏳ Your exam is scheduled but hasn't started yet. Stay prepared!",
  'standby-locked': "⏱️ Your exam will begin soon! Get ready to start.",
  missing: alertExamStatus.missing2,
  notEnrolled: "🚫 You are not enrolled in this exam. Please check with your school.",
  ended: "🔒 This exam is now ended. You can no longer submit your answers."
};

export const linkMessageAlert={
  feedback:{
    href: FEEDBACK_FORM_URL,
    label: 'Give Feedback 😊'
  }
}

// Dummy data for chat log
export const chatLog = [
  {
    message: examStatusAlerts.graded,
    timeStamp: dayjs().format('DD MMM YYYY HH:mm')
  },
  {
    message: examStatusAlerts.ongoing,
    timeStamp: dayjs().format('DD MMM YYYY HH:mm')
  },
  {
    message: examStatusAlerts.pending,
    timeStamp: dayjs().format('DD MMM YYYY HH:mm')
  },
  {
    message: examStatusAlerts['standby-locked'],
    timeStamp: dayjs().format('DD MMM YYYY HH:mm')
  },
  {
    message: examStatusAlerts.missing,
    timeStamp: dayjs().format('DD MMM YYYY HH:mm')
  },
  {
    message: examStatusAlerts.notEnrolled,
    timeStamp: dayjs().format('DD MMM YYYY HH:mm')
  },
  {
    message: examStatusAlerts.ended,
    timeStamp: dayjs().format('DD MMM YYYY HH:mm')
  }
];